// HEAL-86 (stage-1 §8.1) — экран на время окна техработ.
//
// Одна кнопка — «Обновить»: перезагрузка заново спрашивает сервер. Окно открыто —
// экран вернётся сам по первому же ответу; закрыто — человек окажется там, где был.
// Перезагрузка, а не повтор запросов: экраны под этим флагом размонтированы, и
// поднимать их по одному некому.

import { Wrench } from 'lucide-react';

import { MobileFrame } from '@/components/layout/MobileFrame';
import { Button } from '@/components/ui/button';

export function MaintenanceScreen({
  onRefresh = () => window.location.reload(),
}: {
  onRefresh?: () => void;
}) {
  return (
    <MobileFrame>
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Wrench className="h-7 w-7" aria-hidden />
        </div>
        <h1 className="text-lg font-bold">Технические работы</h1>
        <p className="text-sm leading-relaxed text-muted-foreground">
          Обновляем приложение. Это займёт до часа. Ваши данные на месте.
        </p>
        <Button type="button" onClick={onRefresh} className="mt-2 w-full">
          Обновить
        </Button>
      </div>
    </MobileFrame>
  );
}
